var React = require('react');

function Masking (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M21 13a9 9 0 0 1-9 9 9 9 0 0 1-9-9l.03-8.57C5.68 2.88 8.76 2 12.05 2c3.25 0 6.31.87 8.95 2.38V13m-8 6.93c3.39-.49 6-3.43 6-6.93V5.59C16.9 4.57 14.54 4 12.05 4c-2.55 0-4.97.6-7.11 1.66L5 13c0 3.5 2.63 6.44 6 6.93V18h2v1.93M11 16H8l-2-3 3 1h1l1-1h2l1 1h1l3-1-2 3h-3l-1-1-1 1M6 9.03c.64-.63 1.5-.98 2.5-.98.95 0 1.84.35 2.5.98-.66.62-1.55.97-2.5.97-1 0-1.86-.35-2.5-.97m7 0c.64-.63 1.5-.98 2.5-.98.95 0 1.84.35 2.5.98-.66.62-1.55.97-2.5.97-1 0-1.86-.35-2.5-.97z"}));
}

Masking.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Masking;

Masking.default = Masking;
